<template>
    <nav class="relative w-full flex flex-wrap items-center justify-between my-4 py-3 bg-grey-100 navbar navbar-expand-lg navbar-light">
        <div class="container-fluid w-full flex flex-wrap items-center justify-between px-6">
            <nav class="bg-grey w-full" aria-label="breadcrumb">
                <ol class="list-reset flex">
                    <li><Link href="/admin" class="text-grey-300 hover:font-bold">Home</Link></li>
                    <span class="text-grey-300 mx-2">/</span>
                    <li v-for="(item, key) in items">
                        <Link :href="item.path" class="text-grey-300 hover:font-bold" :class="{'font-bold': $page.url === item.path }">{{ item.title }}</Link>
                        <span v-if="key+1 != items.length" class="text-grey-300 mx-2">/</span>
                    </li>
                </ol>
            </nav>
        </div>
    </nav>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    props: {
        items: Array
    },
    components: {
        Link,
    },
    methods: {

    },
    computed: {
    }
}
</script>
